import React from 'react';

const NotFound = () => <h1>Nothing to see here</h1>;
export default NotFound;
